import { all } from 'redux-saga/effects';
import localizationSaga from '../containers/Localization/sagas';
import dashboardSaga from '../scenes/Dashboard/sagas';
import contactProfileSaga from '../scenes/ContactProfile/sagas';
import requestBuilderSaga from '../scenes/RequestBuilder/sagas';
import userSaga from './user';
import positionProfileSaga from '../scenes/PositionProfile/sagas';
import teamListSaga from '../containers/TeamList/sagas';
import candidateFormSaga from '../scenes/CandidateForm/sagas';
import refSurveySaga from '../scenes/SurveyUI/sagas';
import surveyBuilderSaga from '../scenes/SurveyBuilder/sagas';
import historySaga from './history';
import settingsSaga from '../scenes/Settings/sagas';
import bulkActionsSaga from '../containers/CandidatesBulkActions/sagas';
import searchSaga from '../scenes/GlobalSearch/sagas';
import reportSaga from '../containers/ShareReportModal/sagas';
import positionsSaga from '../containers/ChoosePositionPage/sagas';
import mergePositionsSaga from '../containers/MergePositions/sagas';
import prospectsBulkActionsSaga from '../containers/ProspectsBulkActions/sagas';
import mergeContactsSaga from '../containers/MergeContacts/sagas';
import sendReminderSaga from '../containers/SendReminderModal/sagas';
import manualInputSaga from '../containers/SurveyManualInput/sagas';
import integrationCallbackSaga from '../containers/IntegrationCallback/sagas';

export default function* rootSaga() {
  yield all([
    userSaga(),
    dashboardSaga(),
    localizationSaga(),
    contactProfileSaga(),
    requestBuilderSaga(),
    positionProfileSaga(),
    teamListSaga(),
    candidateFormSaga(),
    refSurveySaga(),
    surveyBuilderSaga(),
    historySaga(),
    settingsSaga(),
    bulkActionsSaga(),
    prospectsBulkActionsSaga(),
    searchSaga(),
    reportSaga(),
    positionsSaga(),
    mergePositionsSaga(),
    mergeContactsSaga(),
    sendReminderSaga(),
    manualInputSaga(),
    integrationCallbackSaga()
  ]);
}
